import axios from './axios'
import qs from 'qs';
let baseUrl = '/api/adRule/';
/**
 *
 * 
 */
export default {
  // 退货管理列表
  list(data) {
    return axios.get(baseUrl + 'getAllRuleData', {
      params: data
    });
  },

  edit(data) {
    return axios.post(baseUrl + 'editRuleData', qs.stringify(data));
  },
}
